// extracted by mini-css-extract-plugin
export default {"container":"titleBanner_container__9zLAh","ncfContainer":"titleBanner_ncfContainer__q1LGW","itebisLabel":"titleBanner_itebisLabel__dZ-Ar"};